import { ADD_BASIC_INPUT_HANDLER_CURRENT_REQUEST } from "../../../enums/Request/currentRequestControls.types";

export const addBasicInputHandlerCurrentRequest = ({ field, value }) => {
    return {
        type: ADD_BASIC_INPUT_HANDLER_CURRENT_REQUEST,
        payload: { field, value },
    };
};
